<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectResultConfigItemChild-modal ref="modalForm" @ok="modalFormOk" :configItemId="configItemId"></projectResultConfigItemChild-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectResultConfigItemChildModal from './modules/ProjectResultConfigItemChildModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "ProjectResultConfigItemChildList",
    mixins:[JeecgListMixin],
    components: {
      ProjectResultConfigItemChildModal
    },
    props:{
      configItemId:''
    },
    data () {
      return {
        description: '测评逻辑明细配置项子配置管理页面',
        // 表头
        columns: [
		   {
            title: '名称',
            align:"center",
            dataIndex: 'name'
           },
		   {
            title: 'CODE',
            align:"center",
            dataIndex: 'code'
           },
		   {
            title: '最小值',
            align:"center",
            dataIndex: 'min'
           },
		   {
            title: '最大值',
            align:"center",
            dataIndex: 'max'
           },
		   // {
       //      title: '评价',
       //      align:"center",
       //      dataIndex: 'appraise'
       //     },
		   // {
       //      title: '建议',
       //      align:"center",
       //      dataIndex: 'suggest'
       //     },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectResultConfigItemChild/list",
          delete: "/project/projectResultConfigItemChild/delete",
       },
        isorter:{
          column: '',
          order: '',
        },
        disableMixinCreated:true,
      }
  },
    watch:{
      configItemId(){
        this.baseQueryParam = {configItemId:this.configItemId}
        this.loadData()
      }
    },
  computed: {
  },
    mounted(){

    },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>